import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";

export const getIsService = (type: ProductPreviewTypes) => {
    switch (type) {
      case ProductPreviewTypes.appointment:
      case ProductPreviewTypes.consultation:
        return true;
      case ProductPreviewTypes.general:
      default:
        return false;
    }
  };